import { makeStyles } from '@mui/styles'
import theme from 'theme'

// Point-up pentagon card, same silhouette as the ACT-page domain mesh and
// the AI-page pentagon (50%,0% / 100%,38% / 82%,100% / 18%,100% / 0%,38%),
// up to three per row.
export const useStyles = makeStyles( () => ( {
	grid: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: '24px',
		[ theme.breakpoints.up( 'laptop' ) ]: {
			gap: '32px',
		},
		// Same soft outer glow as the ACT-page domain mesh. Each card's
		// clip-path already crops its opaque fill to the pentagon outline,
		// so this traces every card's silhouette individually (they don't
		// touch, so there's no seam to worry about).
		filter: 'drop-shadow(0 0 4px var(--glow)) drop-shadow(0 0 14px var(--glow))',
	},
	// Fixed px width/height (not percentage/calc) — same technique as the
	// AI-page pentagon. A flex item whose own width is itself percentage
	// or calc()-based resolves percentage padding-top/bottom against an
	// earlier, pre-wrap hypothetical width (a flexbox quirk that blew this
	// card up to ~950px tall the first time); a literal px width sidesteps
	// that entirely.
	pentagon: {
		position: 'relative',
		// Same mobile size as the ACT-page domain pentagons (260x247).
		width: '260px',
		height: '247px',
		// CSS padding percentages ALWAYS resolve against the CONTAINING
		// BLOCK's width (the flex parent's content width here) — never the
		// element's own box, unlike clip-path's self-referential percentages.
		// So the content padding below is precomputed in px against THIS
		// box's own dimensions (26% top / 19% sides / 8% bottom of the box's
		// own height/width, matching the clipped pentagon's safe zone) —
		// percentages here would silently blow the box up (confirmed: it
		// rendered ~380px wide against a ~1000px flex-parent width).
		paddingTop: '64px',
		paddingLeft: '49px',
		paddingRight: '49px',
		paddingBottom: '20px',
		[ theme.breakpoints.up( 'laptop' ) ]: {
			width: '320px',
			height: '304px',
			paddingTop: '79px',
			paddingLeft: '61px',
			paddingRight: '61px',
			paddingBottom: '24px',
		},
		boxSizing: 'border-box',
		clipPath: 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		textAlign: 'center',
		color: 'var(--ink)',
		textDecoration: 'none',
		// Opaque fill (same color as the page background) so the grid's
		// drop-shadow filter has an actual alpha silhouette to trace —
		// a transparent box casts no shadow.
		backgroundColor: 'var(--bg)',
	},
	pentagonAvailable: {
		cursor: 'var(--cursor-pointer)',
		transition: 'background-color 0.25s ease',
		'&:hover': {
			backgroundColor: 'var(--hover)',
		},
	},
	// clip-path crops the fill but not a CSS border, so the visible outline
	// is a separate absolutely-positioned SVG polygon (same technique as
	// the ACT-page domain mesh).
	pentagonOutline: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		pointerEvents: 'none',
	},
} ) )
